import { Injectable, inject, effect } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import Gleap from 'gleap';
import { AuthStore } from '@app/core/auth/stores/auth-store';
import { environment } from '@environ/environment';

@Injectable({ providedIn: 'root' })
export class GleapService {
  private authStore = inject(AuthStore);
  private translate = inject(TranslateService);

  constructor() {
    if (!environment.enableGleap) return;

    Gleap.initialize("Sifo8CxLM2GzOwrhzgsDcfWUqzTahICp");
    Gleap.hideAiChatbar();
    Gleap.setEnvironment(environment.gleapEnvironment);

    const initialLang = this.translate.currentLang || this.translate.getDefaultLang();
    if (initialLang) Gleap.setLanguage(initialLang);

    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe(event => {
      Gleap.setLanguage(event.lang);
    });

    effect(() => {
      const user = this.authStore.user();
      if (user) {
        Gleap.identify(String(user.id), {
          name: `${user.firstName} ${user.lastName}`.trim() || null,
          email: user.email || null,
        });
      } else {
        Gleap.clearIdentity();
      }
    });
  }
}
